import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {IPaginatedResponse, IService} from 'maps-angular-components';
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {handleError} from "../shared/util/error-util";
import {CarteiraCNPJ} from "./carteira.cnpj.model";

@Injectable({
    providedIn: 'root'
})
export class CarteiraCnpjService implements IService<CarteiraCNPJ> {

    url: string = "/v1/carteiras";

    constructor(private http: HttpClient) {
    }

    parsePaginatedResponse(response): IPaginatedResponse<CarteiraCNPJ> {
        return {
            total: null,
            data: response.map(item => new CarteiraCNPJ(item))
        };
    };

    autocomplete(identificador: string, endpoint: string = ''): Observable<CarteiraCNPJ> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const options = {headers};
        return this.http.get<any>(`${this.url}/${endpoint}?val=${encodeURIComponent(identificador)}`, options).pipe(catchError(handleError));
    }

}
